import { Reducer } from 'redux';
import { RequestableDataWithEntityError } from 'src/store/types';
import { LoanStatus } from 'src/types/LoanStatus';
import { isType } from 'typescript-fsa';
import {
  loanStatusRequestSuccess,
  loanStatusRequestFail,
  loanStatusRequest,
  updateLoanStatusActions,
} from './loan_status.actions';

/**
 * State
 */
export type State = RequestableDataWithEntityError<LoanStatus>;

export const defaultState: State = {
  loading: false,
  error: {},
  lastUpdated: 0,
  data: undefined,
};

/**
 * Reducer
 */
// @ts-ignore
const reducer: Reducer<State> = (state: State = defaultState, action) => {
  if (isType(action, loanStatusRequest)) {
    return { ...state, loading: true };
  }

  if (isType(action, loanStatusRequestSuccess)) {
    const { payload } = action;

    return {
      ...state,
      loading: false,
      data: payload,
      lastUpdated: Date.now(),
    };
  }

  if (isType(action, updateLoanStatusActions.started)) {
    return {
      ...state,
      loading: true,
      error: { ...state.error },
    };
  }

  if (isType(action, updateLoanStatusActions.done)) {
    const { result } = action.payload;
    return {
      ...state,
      loading: false,
      /* @todo this is patch ,need to change the loan status storing method it should not be
      stored as items ,it shoulde be desugard to first array,as of now for updating also strong into
      items in first array to avoid loan status update failure in UI in chat application flow*/
      data: { items: [result] },
      lastUpdated: Date.now(),
      error: { ...state.error },
    };
  }

  if (isType(action, loanStatusRequestFail)) {
    const { payload } = action;

    return {
      ...state,
      loading: false,
      error: { ...state.error, read: payload },
    };
  }

  return state;
};

export default reducer;
